import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { EmptyState } from "@/pages/portal/ui";

/** Guarda de rota por cargo: URL direta não abre a tela protegida. */
export const RequirePermission = ({ permission, children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/portal/login" replace />;
  if (!(user.permissions || []).includes(permission)) {
    return (
      <EmptyState
        testId="permission-denied"
        title="Acesso não autorizado"
        hint="Seu cargo não tem permissão para esta área do Portal. Fale com a Diretoria se precisar de acesso."
        description="Seu cargo não tem permissão para esta área do Portal. Fale com a Diretoria se precisar de acesso."
      />
    );
  }
  return children;
};
